'use strict';

export const JSON_API_ERROR_MESSAGES = {
	PAGINATE_AND_LIMIT_CONFLICT: 'Cannot paginate and limit at the same time',
	NO_PAGINATION_STRATEGY_SET: 'No Pagination Strategy has been set',
	NO_PAGINATION_OPTIONS_SET: 'No Pagination Options have been set',
	CANNOT_CREATE_FROM_EXISTING: 'Cannot create new resource from existing. Use update instead',
	CANNOT_DELETE_WITHOUT_ID: 'Cannot delete resource without ID',
	CANNOT_UPDATE_WITHOUT_ID: 'Cannot update resource without ID',
	NO_SELF_LINK: 'Cannot find self URL',
	ALREADY_INITIALIZED: 'Tried to initialize but already is initialized',
	NO_ENTITY_MANAGER: 'Tried to initialize resource but has no connection to EntityManager',
	UNEXPECTED_FILTERS_TYPE: 'Expected Filters to be of type Array, found ',
	UNEXPECTED_RELATIONSHIPS_TYPE: 'Expected Relationships to be of type Array, found ',
	UNEXPECTED_FIELDS_FILTERS_TYPE: 'Expected Fields to be of type Array, found ',
	UNEXPECTED_SORT_FILTERS_TYPE: 'Expected Sorters to be of type Array, found ',
	NOT_A_RESOURCE: 'Not a resource: ',
	NOT_AN_INSTANCE_OF: 'Cannot add element to collection as it is not an instance of ',
	NO_INDEX_OR_ELEMENT: 'Must provide either an element or index to remove',
	NO_BASE_URL_SET: 'No BaseURL set, ignoring request',
	INVALID_URL_APPENDIX: 'Invalid URL Appendix provided',
	RESOURCE_NOT_REGISTERED: 'Resource not found or not registered',
	CANNOT_SORT_ON_UNDEFINED_ATTRIBUTE: 'Cannot sort on undefined attributes',
	NOT_A_VALID_RELATIONSHIP: 'Not a valid relationship: '
};
